export default [
  'page',
  'limit',
  'orderBy',
  'orderDirection',
  'debug',
  'isDebug',
]
